import ecomInterceptor from "interceptors/ecomInterceptor";
import { getUserId } from "./cookieService";
import { ILogo } from "Interfaces/interface.logos";

const logoService = {
  async userLogos(): Promise<ILogo[]> {
    try {
      const response = await ecomInterceptor.get("/users/get-user-logos");
      return response.data?.data || response.data;
    } catch (error: any) {
      console.error(
        "Failed to fetch Logos:",
        error?.response?.data || error.message
      );
      throw new Error("Failed to fetch Logos");
    }
  },

  uploadLogo: async ({
    file,
    name,
  }: {
    file: File;
    name: string;
  }): Promise<any> => {
    try {
      const formData = new FormData();
      const userId = getUserId();

      if (!userId) {
        throw new Error("User ID is missing. Cannot upload logo.");
      }
      formData.append("logo", file);
      formData.append("name", name);
      formData.append("userId", userId);

      const response = await ecomInterceptor.post(
        "/users/upload-logo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data?.data || response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Failed to upload logo";
      throw new Error(`uploadLogo error: ${message}`);
    }
  },

  // companyLogoService.ts
  deleteLogo: async (logoIds: string[]): Promise<any> => {
    try {
      const response = await ecomInterceptor.post("/users/upload-logo", {
        removedLogo: logoIds,
        userId: getUserId(),
      });
      return response.data?.data || response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Failed to delete logo";
      throw new Error(`deleteLogo error: ${message}`);
    }
  },
};

export default logoService;
